import { getHall } from '$logic/hall'
import { getRoom } from '$logic/room'
import { decodeSubscriptionPermissions } from '$logic/subscription'
import { administeredChannelsStorage } from './storage'

export async function setAdministeredChannels(hallIds: string[]) {
  const channelIds = (
    await Promise.all(
      hallIds.map(async id => {
        const room = await getRoom(id)
        return room?.type === 'CHANNEL' ? id : undefined
      }),
    )
  ).filter(Boolean)

  return administeredChannelsStorage.set(channelIds)
}

export function getAdministeredChannelsIds() {
  return Object.values(administeredChannelsStorage.get() || [])
}

export function getAdministeredChannels() {
  const ids = getAdministeredChannelsIds()
  return Promise.all(ids.map(id => getHall(id)))
}

export function removeAdministeredChannel(channelId: string) {
  const ids = getAdministeredChannelsIds()
  const foundIndex = ids.findIndex(id => id === channelId)
  if (foundIndex === -1) return

  const filteredIds = ids.slice(0, foundIndex).concat(ids.slice(foundIndex + 1))
  return administeredChannelsStorage.set(filteredIds)
}

export function addAdministeredChannel(channelId: string) {
  const ids = getAdministeredChannelsIds()
  if (ids.includes(channelId)) return

  return administeredChannelsStorage.set(ids.concat(channelId))
}

export async function updateAdministeredChannelByChannelId(
  roomId: string,
  checkRoomTypeToBeChannel = true,
) {
  if (checkRoomTypeToBeChannel) {
    const roomType = (await getRoom(roomId))?.type
    if (roomType !== 'CHANNEL') return
  }

  const { isOwner, isAdmin } = await decodeSubscriptionPermissions(roomId)

  if (isOwner || isAdmin) await addAdministeredChannel(roomId)
  else await removeAdministeredChannel(roomId)
}
